var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6014 21L30.7389 23.9344C30.8832 24.0161 31.0032 24.1347 31.0867 24.278C31.1702 24.4213 31.2142 24.5842 31.2142 24.75C31.2142 24.9158 31.1702 25.0787 31.0867 25.222C31.0032 25.3653 30.8832 25.4839 30.7389 25.5656L22.7702 30.1312C22.4851 30.2958 22.1618 30.3825 21.8327 30.3825C21.5036 30.3825 21.1802 30.2958 20.8952 30.1312L12.9264 25.5656C12.7822 25.4839 12.6621 25.3653 12.5787 25.222C12.4952 25.0787 12.4512 24.9158 12.4512 24.75C12.4512 24.5842 12.4952 24.4213 12.5787 24.278C12.6621 24.1347 12.7822 24.0161 12.9264 23.9344L18.0639 21",
    stroke: "#0094FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7712 22.6309C22.4861 22.7955 22.1628 22.8821 21.8337 22.8821C21.5045 22.8821 21.1812 22.7955 20.8962 22.6309L12.9274 18.0653C12.7831 17.9835 12.6631 17.8649 12.5796 17.7216C12.4961 17.5783 12.4521 17.4155 12.4521 17.2496C12.4521 17.0838 12.4961 16.9209 12.5796 16.7776C12.6631 16.6344 12.7831 16.5158 12.9274 16.434L20.8962 11.8684C21.1812 11.7038 21.5045 11.6172 21.8337 11.6172C22.1628 11.6172 22.4861 11.7038 22.7712 11.8684L30.7399 16.434C30.8842 16.5158 31.0042 16.6344 31.0877 16.7776C31.1712 16.9209 31.2152 17.0838 31.2152 17.2496C31.2152 17.4155 31.1712 17.5783 31.0877 17.7216C31.0042 17.8649 30.8842 17.9835 30.7399 18.0653L22.7712 22.6309Z",
    stroke: "#0094FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/ProjectIcon.6ea32cb8763204931c27d5f113ebace1.svg";
export { ForwardRef as ReactComponent };